<template>
    <div>
      <h2>Forgot Password</h2>
      <form @submit.prevent="handleResetPassword">
        <input v-model="mail" type="mail" placeholder="Enter your mail" required />
        <br/><br/>
        <button type="submit">Reset Password</button>
      </form>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from 'vue'
  import axios from 'axios'
  
  export default defineComponent({
    setup() {
      const mail = ref('')
  
      const handleResetPassword = async () => {
        try {
          await axios.post('/api/forgot-password', { mail: mail.value })
          alert('Check your mail for password reset instructions')
        } catch (error) {
          console.error(error)
        }
      }
  
      return {
        mail,
        handleResetPassword,
      }
    },
  })
  </script>
  